import type { CreditActiveAllocation } from '@frontend/api-types';
import { sortByDate } from '@frontend/duck-tape';

export const getCurrentSubscriptionId = (allocations: CreditActiveAllocation[]): MaybeUndefined<string> => {
  const subscriptionAllocations = allocations.filter((a) => a.creditType === 'SUBSCRIPTION');
  const sortByCreatedAtDesc = sortByDate({
    getter: (a: CreditActiveAllocation) => a.createdAt,
    sortDirection: 'desc',
  });
  const sortedSubscriptions = sortByCreatedAtDesc(subscriptionAllocations);
  const currentSubscriptionId = sortedSubscriptions[0]?.id;
  return currentSubscriptionId || undefined;
};
